// TODO: might improve this in the future, allowing the URL params to store the selected campus.
// This will enable the user to go to the selected campus in Allocate Staff Unit sheet,
// set the correct campus in TD, TRD and etc.

import { useEffect, useRef } from 'react';
import { useParams } from 'react-router';
import { useAwmsStore } from '../store';

export const useResetCampusOnUwIdChange = () => {
  const { unitWorkloadId } = useParams();
  const setSelectedCampusId = useAwmsStore((state) => state.setSelectedCampusId);
  const lastUwId = useAwmsStore((state) => state.lastUwId);
  const setLastUwId = useAwmsStore((state) => state.setLastUwId);
  const prevUwIdRef = useRef<number | null>(null);

  const uwId = unitWorkloadId ? parseInt(unitWorkloadId, 10) : null;

  useEffect(() => {
    if (uwId === null || isNaN(uwId)) {
      return;
    }
    if (uwId !== lastUwId) {
      setSelectedCampusId(0);
      setLastUwId(uwId);
    }
    prevUwIdRef.current = uwId;
  }, [uwId, lastUwId, setSelectedCampusId, setLastUwId]);
};
